(function () {
  const INTERVAL_MS = 3000;
  const SELECTOR = "[data-mobile-auto-slider]";
  const ITEM_SELECTOR = ".grid-item, .video-item";

  class MobileAutoSlider {
    constructor(container) {
      this.container = container;
      this.timer = null;
      this.resumeTimer = null;
      this.paused = false;
      this.observer = null;
      this.tick = this.tick.bind(this);
      this.pause = this.pause.bind(this);
      this.resume = this.resume.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    getItems() {
      const itemSelector =
        this.container.dataset.mobileAutoSliderItem || ITEM_SELECTOR;
      return Array.from(this.container.querySelectorAll(itemSelector));
    }

    isActive() {
      const items = this.getItems();
      return (
        items.length > 1 &&
        this.container.scrollWidth > this.container.clientWidth + 1
      );
    }

    getCurrentIndex(items) {
      const scrollLeft = this.container.scrollLeft;
      let index = 0;
      let closestDistance = Infinity;

      items.forEach((item, itemIndex) => {
        const distance = Math.abs(item.offsetLeft - scrollLeft);

        if (distance < closestDistance) {
          closestDistance = distance;
          index = itemIndex;
        }
      });

      return index;
    }

    tick() {
      if (this.paused || !this.isActive()) return;

      const items = this.getItems();
      const currentIndex = this.getCurrentIndex(items);
      const nextIndex = currentIndex + 1 >= items.length ? 0 : currentIndex + 1;

      this.container.scrollTo({
        left: items[nextIndex].offsetLeft,
        behavior: "smooth",
      });
    }

    start() {
      this.stop();

      if (
        !this.isActive() ||
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ) {
        return;
      }

      this.timer = window.setInterval(this.tick, INTERVAL_MS);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    pause() {
      this.paused = true;
      this.stop();

      if (this.resumeTimer) {
        window.clearTimeout(this.resumeTimer);
      }

      this.resumeTimer = window.setTimeout(() => {
        this.paused = false;
        this.start();
      }, INTERVAL_MS);
    }

    resume() {
      // Handled by delayed restart after interaction.
    }

    init() {
      this.destroy();

      if (!this.isActive()) return;

      this.container.addEventListener("touchstart", this.pause, {
        passive: true,
      });
      this.container.addEventListener("mousedown", this.pause);
      this.container.addEventListener("wheel", this.pause, { passive: true });

      window.addEventListener("theme:resize:width", this.onResize);

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.start();
            } else {
              this.stop();
            }
          });
        },
        { threshold: 0.25 },
      );

      this.observer.observe(this.container);
    }

    onResize() {
      this.init();
    }

    destroy() {
      this.stop();

      if (this.resumeTimer) {
        window.clearTimeout(this.resumeTimer);
        this.resumeTimer = null;
      }

      this.observer?.disconnect();
      this.observer = null;

      this.container.removeEventListener("touchstart", this.pause);
      this.container.removeEventListener("mousedown", this.pause);
      this.container.removeEventListener("wheel", this.pause);
      window.removeEventListener("theme:resize:width", this.onResize);
    }
  }

  function initSliders(root = document) {
    root.querySelectorAll(SELECTOR).forEach((container) => {
      if (!container._mobileAutoSlider) {
        container._mobileAutoSlider = new MobileAutoSlider(container);
      }

      container._mobileAutoSlider.init();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initSliders());
  } else {
    initSliders();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initSliders(event.target);
  });
})();
